import { f as k } from "./immer.esm-DKj4WCmc.mjs";
import { useContext as rt, useReducer as St, useEffect as et, useDebugValue as At, createContext as wt, useCallback as ht } from "react";
var h = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const P = Symbol(), st = (i) => !!i[P], mt = (i) => !i[P].c, v = (i) => {
  var u;
  const { b: l, c: f } = i[P];
  f && (f(), (u = Et.get(l)) == null || u());
}, I = (i, u) => {
  const l = i[P].o, f = u[P].o;
  return l === f || i === f || st(l) && I(l, u);
}, nt = (i, u) => {
  const l = {
    b: i,
    o: u,
    c: null
  }, f = new Promise((a) => {
    l.c = () => {
      l.c = null, a();
    }, u.finally(l.c);
  });
  return f[P] = l, f;
}, Et = /* @__PURE__ */ new WeakMap(), z = (i) => "init" in i, G = "r", L = "w", V = "c", q = "s", ot = "h", gt = "n", Mt = "l", yt = "a", _t = "m", Pt = (i) => {
  const u = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new Map();
  let a, g;
  if ((h && "production") !== "production" && (a = /* @__PURE__ */ new Set(), g = /* @__PURE__ */ new Set()), i)
    for (const [e, t] of i) {
      const n = {
        v: t,
        r: 0,
        y: !0,
        d: /* @__PURE__ */ new Map()
      };
      (h && "production") !== "production" && (Object.freeze(n), z(e) || console.warn(
        "Found initial value for derived atom which can cause unexpected behavior",
        e
      )), u.set(e, n);
    }
  const w = /* @__PURE__ */ new WeakMap(), M = (e, t, n) => {
    let r = w.get(t);
    r || (r = /* @__PURE__ */ new Map(), w.set(t, r)), n.then(() => {
      r.get(e) === n && (r.delete(e), r.size || w.delete(t));
    }), r.set(e, n);
  }, b = (e) => {
    const t = /* @__PURE__ */ new Set(), n = w.get(e);
    return n && (w.delete(e), n.forEach((r, o) => {
      v(r), t.add(o);
    })), t;
  }, C = /* @__PURE__ */ new WeakMap(), y = (e) => {
    let t = C.get(e);
    return t || (t = /* @__PURE__ */ new Map(), C.set(e, t)), t;
  }, p = (e, t) => {
    if (e) {
      const n = y(e);
      let r = n.get(t);
      return r || (r = p(e.p, t), r && n.set(t, r)), r;
    }
    return u.get(t);
  }, S = (e, t, n) => {
    if ((h && "production") !== "production" && Object.freeze(n), e)
      y(e).set(t, n);
    else {
      const r = u.get(t);
      u.set(t, n), f.has(t) || f.set(t, r);
    }
  }, A = (e, t = /* @__PURE__ */ new Map(), n) => {
    if (!n)
      return t;
    const r = /* @__PURE__ */ new Map();
    let o = !1;
    return n.forEach((s) => {
      var c;
      const d = ((c = p(e, s)) == null ? void 0 : c.r) || 0;
      r.set(s, d), t.get(s) !== d && (o = !0);
    }), t.size === r.size && !o ? t : r;
  }, T = (e, t, n, r, o) => {
    const s = p(e, t);
    if (s) {
      if (o && (!("p" in s) || !I(s.p, o)))
        return s;
      "p" in s && v(s.p);
    }
    const c = {
      v: n,
      r: (s == null ? void 0 : s.r) || 0,
      y: !0,
      d: A(e, s == null ? void 0 : s.d, r)
    };
    let d = !(s != null && s.y);
    return !s || !("v" in s) || !Object.is(s.v, n) ? (d = !0, ++c.r, c.d.has(t) && (c.d = new Map(c.d).set(t, c.r))) : c.d !== s.d && (c.d.size !== s.d.size || !Array.from(c.d.keys()).every((E) => s.d.has(E))) && (d = !0, Promise.resolve().then(() => {
      O(e);
    })), s && !d ? s : (S(e, t, c), c);
  }, $ = (e, t, n, r, o) => {
    const s = p(e, t);
    if (s) {
      if (o && (!("p" in s) || !I(s.p, o)))
        return s;
      "p" in s && v(s.p);
    }
    const c = {
      e: n,
      r: ((s == null ? void 0 : s.r) || 0) + 1,
      y: !0,
      d: A(e, s == null ? void 0 : s.d, r)
    };
    return S(e, t, c), c;
  }, H = (e, t, n, r) => {
    const o = p(e, t);
    if (o && "p" in o) {
      if (I(o.p, n))
        return o.y ? o : { ...o, y: !0 };
      v(o.p);
    }
    M(e, t, n);
    const s = {
      p: n,
      r: ((o == null ? void 0 : o.r) || 0) + 1,
      y: !0,
      d: A(e, o == null ? void 0 : o.d, r)
    };
    return S(e, t, s), s;
  }, R = (e, t, n, r) => {
    if (n instanceof Promise) {
      const o = nt(
        n,
        n.then((s) => {
          T(e, t, s, r, o);
        }).catch((s) => {
          if (s instanceof Promise)
            return st(s) ? s.then(() => {
              _(e, t, !0);
            }) : s;
          $(e, t, s, r, o);
        })
      );
      return H(
        e,
        t,
        o,
        r
      );
    }
    return T(
      e,
      t,
      n,
      r
    );
  }, ut = (e, t) => {
    const n = p(e, t);
    if (n) {
      const r = {
        ...n,
        y: !1
      };
      S(e, t, r);
    } else
      (h && "production") !== "production" && console.warn("[Bug] could not invalidate non existing atom", t);
  }, _ = (e, t, n) => {
    if (!n) {
      const o = p(e, t);
      if (o) {
        if (o.y && "p" in o && !mt(o.p))
          return o;
        if (o.d.forEach((s, c) => {
          if (c !== t)
            if (!l.has(c))
              _(e, c);
            else {
              const d = p(e, c);
              d && !d.y && _(e, c);
            }
        }), Array.from(o.d).every(([s, c]) => {
          const d = p(e, s);
          return d && !("p" in d) && d.r === c;
        }))
          return o.y ? o : { ...o, y: !0 };
      }
    }
    const r = /* @__PURE__ */ new Set();
    try {
      const o = t.read((s) => {
        r.add(s);
        const c = s === t ? p(e, s) : _(e, s);
        if (c) {
          if ("e" in c)
            throw c.e;
          if ("p" in c)
            throw c.p;
          return c.v;
        }
        if (z(s))
          return s.init;
        throw new Error("no atom init");
      });
      return R(e, t, o, r);
    } catch (o) {
      if (o instanceof Promise) {
        const s = nt(
          o,
          o
        );
        return H(
          e,
          t,
          s,
          r
        );
      }
      return $(e, t, o, r);
    }
  }, J = (e, t) => _(t, e), dt = (e, t) => {
    let n = l.get(t);
    return n || (n = B(e, t)), n;
  }, D = (e, t) => !t.l.size && (!t.t.size || t.t.size === 1 && t.t.has(e)), lt = (e, t) => {
    const n = l.get(t);
    n && D(t, n) && F(e, t);
  }, U = (e, t) => {
    const n = l.get(t);
    n == null || n.t.forEach((r) => {
      r !== t && (ut(e, r), U(e, r));
    });
  }, K = (e, t, n) => {
    let r = !0;
    const o = (d, E) => {
      const m = _(e, d);
      if ("e" in m)
        throw m.e;
      if ("p" in m) {
        if (E != null && E.unstable_promise)
          return m.p.then(() => {
            const x = p(e, d);
            return x && "p" in x && x.p === m.p ? new Promise((N) => setTimeout(N)).then(
              () => o(d, E)
            ) : o(d, E);
          });
        throw (h && "production") !== "production" && console.info(
          "Reading pending atom state in write operation. We throw a promise for now.",
          d
        ), m.p;
      }
      if ("v" in m)
        return m.v;
      throw (h && "production") !== "production" && console.warn(
        "[Bug] no value found while reading atom in write operation. This is probably a bug.",
        d
      ), new Error("no value found");
    }, s = (d, E) => {
      let m;
      if (d === t) {
        if (!z(d))
          throw new Error("atom not writable");
        b(d).forEach((tt) => {
          tt !== e && R(tt, d, E);
        });
        const N = p(e, d), pt = R(e, d, E);
        N !== pt && U(e, d);
      } else
        m = K(e, d, E);
      return r || O(e), m;
    }, c = t.write(o, s, n);
    return r = !1, c;
  }, W = (e, t, n) => {
    const r = K(n, e, t);
    return O(n), r;
  }, ft = (e) => !!e.write, B = (e, t, n) => {
    const r = {
      t: new Set(n && [n]),
      l: /* @__PURE__ */ new Set()
    };
    if (l.set(t, r), (h && "production") !== "production" && g.add(t), _(void 0, t).d.forEach((s, c) => {
      const d = l.get(c);
      d ? d.t.add(t) : c !== t && B(e, c, t);
    }), ft(t) && t.onMount) {
      const s = (d) => W(t, d, e), c = t.onMount(s);
      e = void 0, c && (r.u = c);
    }
    return r;
  }, F = (e, t) => {
    var n;
    const r = (n = l.get(t)) == null ? void 0 : n.u;
    r && r(), l.delete(t), (h && "production") !== "production" && g.delete(t);
    const o = p(e, t);
    o ? ("p" in o && v(o.p), o.d.forEach((s, c) => {
      if (c !== t) {
        const d = l.get(c);
        d && (d.t.delete(t), D(c, d) && F(e, c));
      }
    })) : (h && "production") !== "production" && console.warn("[Bug] could not find atom state to unmount", t);
  }, Q = (e, t, n, r) => {
    const o = new Set(n.d.keys());
    r == null || r.forEach((s, c) => {
      if (o.has(c)) {
        o.delete(c);
        return;
      }
      const d = l.get(c);
      d && (d.t.delete(t), D(c, d) && F(e, c));
    }), o.forEach((s) => {
      const c = l.get(s);
      c ? c.t.add(t) : l.has(t) && B(e, s, t);
    });
  }, O = (e) => {
    if (e) {
      y(e).forEach((n, r) => {
        const o = u.get(r);
        if (n !== o) {
          const s = l.get(r);
          s == null || s.l.forEach((c) => c(e));
        }
      });
      return;
    }
    for (; f.size; ) {
      const t = Array.from(f);
      f.clear(), t.forEach(([n, r]) => {
        const o = p(void 0, n);
        if (o && o.d !== (r == null ? void 0 : r.d) && Q(void 0, n, o, r == null ? void 0 : r.d), r && !r.y && (o != null && o.y))
          return;
        const s = l.get(n);
        s == null || s.l.forEach((c) => c());
      });
    }
    (h && "production") !== "production" && a.forEach((t) => t());
  }, at = (e) => {
    y(e).forEach((n, r) => {
      const o = u.get(r);
      (!o || n.r > o.r || n.y !== o.y || n.r === o.r && n.d !== o.d) && (u.set(r, n), n.d !== (o == null ? void 0 : o.d) && Q(e, r, n, o == null ? void 0 : o.d));
    });
  }, X = (e, t) => {
    t && at(t), O(void 0);
  }, Y = (e, t, n) => {
    const o = dt(n, e).l;
    return o.add(t), () => {
      o.delete(t), lt(n, e);
    };
  }, Z = (e, t) => {
    for (const [n, r] of e)
      z(n) && (R(t, n, r), U(t, n));
    O(t);
  };
  return (h && "production") !== "production" ? {
    [G]: J,
    [L]: W,
    [V]: X,
    [q]: Y,
    [ot]: Z,
    [gt]: (e) => (a.add(e), () => {
      a.delete(e);
    }),
    [Mt]: () => g.values(),
    [yt]: (e) => u.get(e),
    [_t]: (e) => l.get(e)
  } : {
    [G]: J,
    [L]: W,
    [V]: X,
    [q]: Y,
    [ot]: Z
  };
}, bt = (i, u) => ({ s: u ? u(i).SECRET_INTERNAL_store : Pt(i) }), j = /* @__PURE__ */ new Map(), ct = (i) => (j.has(i) || j.set(i, wt(bt())), j.get(i));
let Tt = 0;
function Ot(i, u) {
  const l = `atom${++Tt}`, f = {
    toString: () => l
  };
  return typeof i == "function" ? f.read = i : (f.init = i, f.read = (a) => a(f), f.write = (a, g, w) => g(f, typeof w == "function" ? w(a(f)) : w)), u && (f.write = u), f;
}
function vt(i, u) {
  const l = ct(u), f = rt(l), { s: a, v: g } = f, w = (S) => {
    const A = a[G](i, S);
    if ((h && "production") !== "production" && !A.y)
      throw new Error("should not be invalidated");
    if ("e" in A)
      throw A.e;
    if ("p" in A)
      throw A.p;
    if ("v" in A)
      return A.v;
    throw new Error("no atom value");
  }, [[M, b, C], y] = St(
    (S, A) => {
      const T = w(A);
      return Object.is(S[1], T) && S[2] === i ? S : [A, T, i];
    },
    g,
    (S) => {
      const A = w(S);
      return [S, A, i];
    }
  );
  let p = b;
  return C !== i && (y(M), p = w(M)), et(() => {
    const { v: S } = f;
    S && a[V](i, S);
    const A = a[q](
      i,
      y,
      S
    );
    return y(S), A;
  }, [a, i, f]), et(() => {
    a[V](i, M);
  }), At(p), p;
}
function Ct(i, u) {
  const l = ct(u), { s: f, w: a } = rt(l);
  return ht(
    (w) => {
      if ((h && "production") !== "production" && !("write" in i))
        throw new Error("not writable atom");
      const M = (b) => f[L](i, w, b);
      return a ? a(M) : M();
    },
    [f, a, i]
  );
}
function zt(i, u) {
  return "scope" in i && (console.warn(
    "atom.scope is deprecated. Please do useAtom(atom, scope) instead."
  ), u = i.scope), [
    vt(i, u),
    Ct(i, u)
  ];
}
const it = {
  currentPage: 1,
  bulk_records: 0,
  selectAll: {
    select_all: !1,
    selected: !1
  },
  selectedRows: []
}, It = Ot(it), Vt = (i) => k(i, (u) => (u.selectedRows = [], u)), kt = (i) => k(i, (u) => (u.selectAll = it.selectAll, u)), Dt = (i) => k(i, (u) => (u.selectAll = {
  select_all: !0,
  selected: !0
}, u)), Ut = (i) => k(i, (u) => (u.currentPage = 1, u));
export {
  zt as a,
  it as b,
  kt as c,
  Dt as d,
  Ut as e,
  Vt as r,
  It as t,
  vt as u
};
//# sourceMappingURL=table-XsUAem3c.mjs.map
